<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="isBatch?'批量授权':'账户授权 - '+(accountList[0]||{}).user_name"
        :close-on-press-escape="false"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <div>
            <el-form ref="form" :model="formItem" :rules="rules" label-width="120px" class="pr40">
                <el-form-item label="授权人：" prop="user_ids" :class="{'label-required':isBatch}" v-if="!isBatch">
                    <ESelect v-model="formItem.user_ids" multiple filterable class="full-w"
                               placeholder="根据输入的成员名称关键字搜索成员">
                        <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </ESelect>
                </el-form-item>

                <template v-else>
                    <el-form-item label="操作项：" prop="type" class="label-required">
                        <el-radio-group v-model="formItem.type" @change="changeType">
                            <el-radio label="1">添加授权人</el-radio>
                            <el-radio label="2">删除授权人</el-radio>
                            <el-radio label="3">替换筛选人</el-radio>
                        </el-radio-group>
                        <p v-if="formItem.type=='3'" class="text-color-gray font12px">将当前授权人全部替换为新的授权人，可以是一对一或多对多。</p>
                    </el-form-item>
                    <el-form-item label="授权人：" prop="user_ids" class="label-required" v-if="formItem.type=='1'||formItem.type=='2'">
                        <ESelect v-model="formItem.user_ids" multiple filterable class="full-w"
                                   placeholder="根据输入的成员名称关键字搜索成员">
                            <el-option
                                v-for="item in userList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="当前授权人：" prop="user_ids" class="label-required" v-if="formItem.type=='3'">
                        <ESelect v-model="formItem.user_ids" multiple filterable class="full-w"
                                   placeholder="根据输入的成员名称关键字搜索成员">
                            <el-option
                                v-for="item in userList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="新的授权人：" prop="user_ids1" class="label-required" v-if="formItem.type=='3'">
                        <ESelect v-model="formItem.user_ids1" multiple filterable class="full-w"
                                   placeholder="根据输入的成员名称关键字搜索成员">
                            <el-option
                                v-for="item in userList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>



                </template>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" 
            v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: `${isBatch? '批量授权(取消)' : '授权(取消)'}` }"
            @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" 
            v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: `${isBatch? '批量授权(保存)' : '授权(保存)'}` }"
            @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/mediaAccount.js';
    import utils from '@/libs/utils.js'
    import matomo from '@/utils/matomo.js'
    export default {
        name: "AccountAuth",
        components: {},
        props: {
        },
        data() {
            let _this = this;
            const validateUserIds1 = (rule, value, callback) => {
                if (_this.formItem.type!='3') {
                    callback();
                } else if (_this.formItem.user_ids1.length<=0) {
                    callback(new Error('请选择新的授权人'));
                } else {
                    callback();
                }
            };
            return {
                dialogVisible: false,
                submitLoading: false,
                formItem: {
                    type:'1',
                    user_ids: [],
                    user_ids1: [],
                },
                rules: {
                    user_ids: [
                        {type: 'array', required: _this.isBatch, message: '请选择授权人', trigger: 'change'}
                    ],
                    user_ids1:[
                        { validator: validateUserIds1, trigger: 'change' }
                    ],
                },
                userList: [],
                accountList:[],

            }
        },
        computed: {
            isBatch() {
                return Array.isArray(this.accountList) && this.accountList.length > 1;
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.userList = [];
                this.resetForm();
            },
            resetForm() {
                console.log('resetForm')
                this.formItem.user_ids = [];
                this.formItem.user_ids1 = [];
                this.formItem.type = '1';
                this.userList = [];
                this.submitLoading = false;
                this.$refs['form'].clearValidate();
            },
            showModal(accountList) {
                this.accountList = utils.deepClone(accountList);
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.getYYUserList().then(()=>{
                        if (!this.isBatch) {
                            let account = this.accountList[0];
                            let idArrStr = account?account.authorize_user_id||"":"";
                            let idArr = idArrStr.split(',');
                            let userIdList = this.userList.map(item=>item.id);
                            let checkIds = [];
                            idArr.forEach(item=>{
                                if(userIdList.includes(item)){
                                    checkIds.push(item);
                                }
                            });
                            this.formItem.user_ids = checkIds;
                        }else{
                            this.formItem.user_ids = [];
                            this.formItem.user_ids1 = [];
                        }
                    });
                    this.$refs['form'].clearValidate();
                })
            },
            getYYUserList() {
                return API.getYYUserList({
                    status:'1',
                }).then(res => {
                    this.userList = res.data || [];
                }, (err) => {
                    console.log('getYYUserList error', err);
                    this.userList = [];
                });
            },
            changeType(){
                if(this.formItem.type=='3') {
                    matomo.trackEvent('媒体账户绑定', '点击', '批量授权(替换筛选人)');
                }else if(this.formItem.type=='2') {
                    matomo.trackEvent('媒体账户绑定', '点击', '批量授权(删除授权人)');
                }else if(this.formItem.type=='1') {
                    matomo.trackEvent('媒体账户绑定', '点击', '批量授权(添加授权人)');
                }
                this.$refs['form'].clearValidate();
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let companyData = this.accountList.map(item => (item.plat_id + '-' + item.company_id));

                        let data = {
                            user_ids: this.formItem.user_ids,
                            plat_company: companyData,
                        };

                        if (this.isBatch) {
                            if(this.formItem.user_ids.length<=0){
                                return this.$message.error('请选择授权人');
                            }
                            data.type = this.formItem.type;
                            if(this.formItem.type==3){
                                data.current_user_ids = this.formItem.user_ids;
                                data.user_ids = this.formItem.user_ids1;
                            }
                            this.submitLoading = true;
                            API.accountBatchAuth(data).then(res => {
                                this.$message.success(res.info || '操作成功');
                                this.dialogVisible = false;
                                this.resetForm();
                                this.$emit('update');
                            }, (err) => {
                                console.log('accountBatchAuth error', err);
                                let errData = err.data||{};
                                if(err.code==0&&((errData.company||[]).length>0||errData.msg)){
                                    let htmlStr = `<div style="max-height: 150px;overflow: auto;"><p class="text-bold mb10">${errData.msg}</p><p class="text-color-error mb10 font12px">继续授权：表示仍然将该成员设置为授权人；<br/>跳过：表示不添加该成员为授权人（若替换授权人会去除该账户的已选当前授权人）；</p>`;
                                    (errData.company||[]).forEach(item=>{
                                        htmlStr += `<p class="ml20 font12px break-word">${item}</p>`;
                                    });
                                    htmlStr+=`</div>`;

                                    this.$confirm(htmlStr, err.info || '操作失败', {
                                        confirmButtonText: '跳过',
                                        cancelButtonText: '继续授权',
                                        dangerouslyUseHTMLString: true,
                                        closeOnClickModal:false,
                                        closeOnPressEscape:false,
                                        distinguishCancelAndClose:true,
                                        customClass:'width550',
                                        type: 'warning'
                                    }).then(() => {
                                        /*reconfirmed:已是账户负责人时的二次确认参数：1-继续授权，2-跳过*/
                                        this.confirmBatchAuth(data,'2');
                                    }).catch((action ) => {
                                        /* 区分取消与关闭 */
                                        if(action =='cancel'){
                                            this.confirmBatchAuth(data,'1');
                                        }
                                    });

                                    // let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                                    // err.data.forEach(item=>{
                                    //     htmlStr += `<p class="ml20 font12px">${item.plat_name} ${item.user_name} ${item.name} 已是负责人，无需授权;</p>`;
                                    // });
                                    // htmlStr+=`</div>`;
                                    // this.$alert(htmlStr, err.info||'授权结果', {
                                    //     confirmButtonText: '确定',
                                    //     dangerouslyUseHTMLString: true,
                                    //     type: 'error',
                                    //     callback: () => {
                                    //         this.dialogVisible = false;
                                    //         this.resetForm();
                                    //         this.$emit('update');
                                    //     }
                                    // });
                                }else{
                                    this.$message.error(err.info || '操作失败');
                                    this.submitLoading = false;
                                }
                            });
                        } else {
                            this.submitLoading = true;
                            API.accountAuth(data).then(res => {
                                this.$message.success(res.info || '操作成功');
                                this.dialogVisible = false;
                                this.resetForm();
                                this.$emit('update');
                            }, (err) => {
                                console.log('accountAuth error', err);
                                let errData = err.data||{};
                                if(err.code==0&&((errData.company||[]).length>0||errData.msg)){
                                    let htmlStr = `<div style="max-height: 150px;overflow: auto;"><p class="text-bold mb10">${errData.msg}</p><p class="text-color-error mb10 font12px">继续授权：表示仍然将该成员设置为授权人；<br/>跳过：表示不添加该成员为授权人（若替换授权人会去除该账户的已选当前授权人）；</p>`;
                                    (errData.company||[]).forEach(item=>{
                                        htmlStr += `<p class="ml20 font12px break-word">${item}</p>`;
                                    });
                                    htmlStr+=`</div>`;
                                    this.$confirm(htmlStr, err.info || '操作失败', {
                                        confirmButtonText: '跳过',
                                        cancelButtonText: '继续授权',
                                        dangerouslyUseHTMLString: true,
                                        closeOnClickModal:false,
                                        closeOnPressEscape:false,
                                        distinguishCancelAndClose:true,
                                        customClass:'width550',
                                        type: 'warning'
                                    }).then(() => {
                                        /*reconfirmed:已是账户负责人时的二次确认参数：1-继续授权，2-跳过*/
                                        this.confirmAuth(data,'2');
                                    }).catch((action ) => {
                                        /* 区分取消与关闭 */
                                        if(action =='cancel'){
                                            this.confirmAuth(data,'1');
                                        }
                                    });
                                }else{
                                    this.$message.error(err.info || '操作失败');
                                    this.submitLoading = false;
                                }
                            });
                        }


                    } else {
                        return false;
                    }
                });
            },
            confirmBatchAuth(data,reconfirmed){
                this.submitLoading = true;
                data.reconfirmed = reconfirmed;
                API.accountBatchAuth(data).then(res => {
                    this.$message.success(res.info || '操作成功');
                    this.dialogVisible = false;
                    this.resetForm();
                    this.$emit('update');
                    this.submitLoading = false;
                }, (err) => {
                    this.$message.error(err.info || '操作失败');
                    this.submitLoading = false;
                });
            },
            confirmAuth(data,reconfirmed){
                this.submitLoading = true;
                data.reconfirmed = reconfirmed;
                API.accountAuth(data).then(res => {
                    this.$message.success(res.info || '操作成功');
                    this.dialogVisible = false;
                    this.resetForm();
                    this.$emit('update');
                    this.submitLoading = false;
                }, (err) => {
                    this.$message.error(err.info || '操作失败');
                    this.submitLoading = false;
                });
            },

        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        width: 120px;
    }

</style>
